/* Funday Golf — left-edge dock.
   A vertical rail of tabs pinned to the screen edge. Each tab expands to a
   popup and collapses back to its tab when closed.
   - Welcome: auto-opens per trigger settings, then docks to a tab on close.
     Captures email -> Klaviyo -> reveals the discount code. Hidden for good
     once the visitor subscribes.
   - Reviews: always docked; opens a Judge.me carousel modal on click. */
(function () {
  var dock = document.querySelector('[data-fd-dock]');
  var welcome = document.querySelector('[data-fd-modal="welcome"]');
  var reviews = document.querySelector('[data-fd-modal="reviews"]');
  if (!dock && !welcome && !reviews) return;

  var SUB_KEY = 'fd_popup_subscribed';
  var SEEN_KEY = 'fd_popup_seen';

  var openOverlay = null;
  function openModal(overlay) {
    if (!overlay) return;
    if (openOverlay && openOverlay !== overlay) closeModal(openOverlay);
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    openOverlay = overlay;
    var input = overlay.querySelector('[data-fd-pop-email]');
    if (input) { try { input.focus(); } catch (e) {} }
  }
  function closeModal(overlay) {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (openOverlay === overlay) openOverlay = null;
  }

  /* Tab clicks open the matching modal. */
  if (dock) {
    Array.prototype.forEach.call(dock.querySelectorAll('[data-fd-open]'), function (btn) {
      btn.addEventListener('click', function () {
        var which = btn.getAttribute('data-fd-open');
        openModal(which === 'reviews' ? reviews : welcome);
      });
    });
  }

  /* Generic close wiring for any overlay (X, backdrop, Esc). */
  function wireClose(overlay) {
    if (!overlay) return;
    Array.prototype.forEach.call(overlay.querySelectorAll('[data-fd-pop-close]'), function (el) {
      el.addEventListener('click', function (ev) {
        if (ev.target === el || el.hasAttribute('data-fd-pop-x')) closeModal(overlay);
      });
    });
  }
  wireClose(welcome);
  wireClose(reviews);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openOverlay) closeModal(openOverlay);
  });

  /* ---- Welcome: auto-open triggers + Klaviyo signup ---- */
  if (welcome) {
    var subscribed = false;
    try { subscribed = !!localStorage.getItem(SUB_KEY); } catch (e) {}

    // Already subscribed? Remove the welcome tab and skip all of this.
    if (subscribed) {
      var wtab = dock && dock.querySelector('[data-fd-open="welcome"]');
      if (wtab) wtab.parentNode.removeChild(wtab);
    } else {
      var trigger = welcome.getAttribute('data-trigger') || 'delay_or_exit';
      var delay = parseInt(welcome.getAttribute('data-delay'), 10); if (isNaN(delay)) delay = 7;
      var scrollPct = parseInt(welcome.getAttribute('data-scroll'), 10); if (isNaN(scrollPct)) scrollPct = 40;
      var showOn = welcome.getAttribute('data-show-on') || 'all';
      var freqDays = parseInt(welcome.getAttribute('data-frequency-days'), 10); if (isNaN(freqDays)) freqDays = 30;

      var useDelay = trigger === 'delay' || trigger === 'delay_or_exit';
      var useExit = trigger === 'exit' || trigger === 'delay_or_exit' || trigger === 'scroll_or_exit';
      var useScroll = trigger === 'scroll' || trigger === 'scroll_or_exit';

      var path = (window.location.pathname || '').toLowerCase();
      var pageBlocked = path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0 ||
        (showOn === 'home' && path !== '/' && path !== '');

      // Should we auto-open on this visit? (Tab is always available regardless.)
      var canAuto = !pageBlocked;
      try {
        var seenAt = localStorage.getItem(SEEN_KEY);
        if (seenAt) {
          if (freqDays <= 0) canAuto = false;
          else {
            var elapsed = Date.now() - parseInt(seenAt, 10);
            if (!isNaN(elapsed) && elapsed < freqDays * 86400000) canAuto = false;
          }
        }
      } catch (e) {}

      var autoTimer = null;
      var autoOpened = false; // fire the auto-open at most once per page load
      function autoOpen() {
        if (autoOpened || openOverlay) return;
        autoOpened = true;
        if (autoTimer) clearTimeout(autoTimer);
        document.removeEventListener('mouseout', onExitTrigger);
        try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch (e) {}
        openModal(welcome);
      }
      function onExitTrigger(e) { if (e.clientY <= 0) autoOpen(); }
      if (canAuto) {
        if (useDelay) autoTimer = setTimeout(autoOpen, delay * 1000);
        if (useExit) document.addEventListener('mouseout', onExitTrigger);
        if (useScroll) {
          var onScroll = function () {
            var h = document.documentElement;
            var max = (h.scrollHeight - h.clientHeight) || 1;
            if (((h.scrollTop || document.body.scrollTop) / max) * 100 >= scrollPct) {
              window.removeEventListener('scroll', onScroll);
              autoOpen();
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
        }
      }

      // Klaviyo submit
      var form = welcome.querySelector('[data-fd-pop-form]');
      var input2 = welcome.querySelector('[data-fd-pop-email]');
      var submitBtn = welcome.querySelector('[data-fd-pop-submit]');
      var submitText = welcome.querySelector('[data-fd-pop-submit-text]');
      var msg = welcome.querySelector('[data-fd-pop-msg]');
      var pop = welcome.querySelector('.fd-pop');
      var copyBtn = welcome.querySelector('[data-fd-pop-copy]');
      var publicKey = welcome.getAttribute('data-public-key') || '';
      var listId = welcome.getAttribute('data-list-id') || '';
      var source = welcome.getAttribute('data-source') || 'Funday — Welcome Dock';
      var code = welcome.getAttribute('data-code') || '';
      var errorMessage = welcome.getAttribute('data-error') || 'Something went wrong. Please try again.';

      if (copyBtn) copyBtn.addEventListener('click', function () {
        try { navigator.clipboard.writeText(code); copyBtn.textContent = 'Copied'; } catch (e) {}
      });
      function showMessage(t) { if (msg) { msg.textContent = t; msg.hidden = false; } }

      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input2.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showMessage(errorMessage); return; }
        if (!publicKey || !listId) { showMessage(errorMessage); return; }
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Saving…';
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15', 'accept': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email } } } },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        }).then(function (res) {
          if (res.status === 202 || res.ok) {
            try { localStorage.setItem(SUB_KEY, '1'); } catch (e) {}
            if (pop) pop.classList.add('is-success');
            var wtab2 = dock && dock.querySelector('[data-fd-open="welcome"]');
            if (wtab2) wtab2.setAttribute('hidden', 'hidden');
            if (typeof fbq !== 'undefined') fbq('track', 'Lead', { content_name: source, content_category: 'welcome_dock' });
            if (typeof window.dataLayer !== 'undefined') window.dataLayer.push({ event: 'newsletter_signup', list_name: source });
          } else { showMessage(errorMessage); }
        }).catch(function () { showMessage(errorMessage); })
          .then(function () {
            if (submitBtn) submitBtn.disabled = false;
            if (submitText) submitText.textContent = welcome.getAttribute('data-button') || 'Get my code';
          });
      });
    }
  }

  /* ---- Reviews: nudge Judge.me to (re)render the carousel when opened ---- */
  if (reviews) {
    var jmRendered = false;
    var origOpen = null;
    var reviewTab = dock && dock.querySelector('[data-fd-open="reviews"]');
    if (reviewTab) reviewTab.addEventListener('click', function () {
      if (jmRendered) return;
      jmRendered = true;
      // Judge.me auto-renders .jdgm-carousel on load; if its script exposes a
      // re-init, call it so the carousel paints inside the just-opened modal.
      try {
        if (window.jdgm && typeof window.jdgm.batchSetupCarousels === 'function') window.jdgm.batchSetupCarousels();
        else if (window.jdgmSetup) window.jdgmSetup();
      } catch (e) {}
    });
  }
})();